// Libs
import { useContext, useEffect } from "react";
import PropTypes from "prop-types";

// Context
import PageLoaderContext from "contexts/PageLoader";

export default function PageLoader({ children, hideChildrenWhenLoading = true, isLoading }) {
  const [, setPageLoaderContext] = useContext(PageLoaderContext);

  useEffect(() => {
    setPageLoaderContext(isLoading);
  }, [setPageLoaderContext, isLoading]);

  if (children && !(hideChildrenWhenLoading && isLoading)) {
    return children;
  }

  return null;
}

PageLoader.propTypes = {
  children: PropTypes.node,
  hideChildrenWhenLoading: PropTypes.bool,
  isLoading: PropTypes.bool.isRequired
};
